/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_DetailsInputs */

const en_delivery_board_details = /** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery Details`)
};

const es_delivery_board_details = /** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de Entrega`)
};

const fr_delivery_board_details = /** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de livraison`)
};

const de_delivery_board_details = /** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferdetails`)
};

const id_delivery_board_details = /** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Pengiriman`)
};

/** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */
const ja_delivery_board_details = en_delivery_board_details;

/** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */
const zh_delivery_board_details = en_delivery_board_details;

/** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */
const ar_delivery_board_details = en_delivery_board_details;

/** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */
const it_delivery_board_details = en_delivery_board_details;

/** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */
const ru_delivery_board_details = en_delivery_board_details;

/** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */
const pt_delivery_board_details = en_delivery_board_details;

/** @type {(inputs: Delivery_Board_DetailsInputs) => LocalizedString} */
const ko_delivery_board_details = en_delivery_board_details;

/**
* | output |
* | --- |
* | "Delivery Details" |
*
* @param {Delivery_Board_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_details = /** @type {((inputs?: Delivery_Board_DetailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_DetailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_details(inputs)
	if (locale === "es") return es_delivery_board_details(inputs)
	if (locale === "fr") return fr_delivery_board_details(inputs)
	if (locale === "de") return de_delivery_board_details(inputs)
	if (locale === "ja") return ja_delivery_board_details(inputs)
	if (locale === "zh") return zh_delivery_board_details(inputs)
	if (locale === "ar") return ar_delivery_board_details(inputs)
	if (locale === "id") return id_delivery_board_details(inputs)
	if (locale === "it") return it_delivery_board_details(inputs)
	if (locale === "ru") return ru_delivery_board_details(inputs)
	if (locale === "pt") return pt_delivery_board_details(inputs)
	return ko_delivery_board_details(inputs)
});